import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, alpha } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import MuiBox from '@mui/material/Box';
import 'react';
import { ReactComponent as ForwardRef } from '../../assets/icons/ErrorSmall.svg.js';
import { ReactComponent as ForwardRef$3 } from '../../assets/icons/InfoSmall.svg.js';
import { ReactComponent as ForwardRef$1 } from '../../assets/icons/SuccessSmall.svg.js';
import { ReactComponent as ForwardRef$2 } from '../../assets/icons/WarningSmall.svg.js';

const Root = styled(MuiBox)(({ theme, width, type = 'warning' }) => {
    const notifictionBackgroundMap = {
        error: theme.palette.error.main,
        success: theme.palette.success.main,
        warning: theme.palette.warning.main,
        info: theme.palette.primary.main,
    };
    const notificationColorMap = {
        error: theme.palette.error.main,
        success: theme.palette.success.main,
        warning: theme.palette.warning.main,
        info: theme.palette['N10'].main,
    };
    return `
    padding: ${theme.spacing(0.8, 2, 0.8, 2)};
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 2px;
    width: ${width !== null && width !== void 0 ? width : '256px'};
    word-break: initial;
    background-color: ${alpha(notifictionBackgroundMap[type], 0.2)};
    color: ${notificationColorMap[type]};
    align-items: center;
  `;
});
const Label = styled(MuiTypography) `
  margin-left: ${({ theme }) => theme.spacing(2)};
  display: flex;
  flex: 1;
`;
const iconMap = {
    error: ForwardRef,
    success: ForwardRef$1,
    warning: ForwardRef$2,
    info: ForwardRef$3,
};
const Notification = (_a) => {
    var { children, type = 'warning', 'data-testid': testId } = _a, rest = __rest(_a, ["children", "type", 'data-testid']);
    const Icon = iconMap[type];
    return (jsxs(Root, Object.assign({ type: type, role: "notification", "data-testid": testId }, rest, { children: [jsx(Icon, {}), jsx(Label, Object.assign({ variant: "body4" }, { children: children }))] })));
};

export { Notification as default };
//# sourceMappingURL=Notification.js.map
